import { useState } from "react";
import { api, errText } from "../../lib/api";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Switch } from "../ui/switch";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { toast } from "sonner";

export const MailSignatureDialog = ({ box, onClose, onSaved }) => {
  const [s, setS] = useState({
    sig_enabled: box.sig_enabled ?? true, sig_logo: box.sig_logo ?? true,
    sig_name: box.sig_name || box.display_name || "", sig_title: box.sig_title || "", sig_phone: box.sig_phone || "",
  });
  const set = (k) => (e) => setS({ ...s, [k]: e?.target ? e.target.value : e });
  const save = () => api.put(`/admin/mail/mailboxes/${encodeURIComponent(box.address)}/signature`, s)
    .then(() => { toast.success("Signature saved"); onSaved(); }).catch((e) => toast.error(errText(e)));

  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg" data-testid="mail-signature-dialog">
        <DialogHeader><DialogTitle>Signature · {box.address}</DialogTitle></DialogHeader>
        <div className="space-y-3">
          <label className="flex items-center justify-between text-sm">Add signature to every email <Switch checked={s.sig_enabled} onCheckedChange={set("sig_enabled")} data-testid="sig-enabled" /></label>
          <label className="flex items-center justify-between text-sm">Show CritterPosts logo <Switch checked={s.sig_logo} onCheckedChange={set("sig_logo")} data-testid="sig-logo" /></label>
          <Input value={s.sig_name} onChange={set("sig_name")} maxLength={80} placeholder="Name (e.g. Gabe Tory)" data-testid="sig-name" />
          <Input value={s.sig_title} onChange={set("sig_title")} maxLength={80} placeholder="Title (e.g. Support Team)" data-testid="sig-title" />
          <Input value={s.sig_phone} onChange={set("sig_phone")} maxLength={40} placeholder="Phone (optional)" data-testid="sig-phone" />
          <div className="border border-slate-200 rounded-xl p-4 bg-white" data-testid="sig-preview">
            <p className="text-[11px] uppercase tracking-wider text-slate-400 font-bold mb-3">Preview</p>
            {s.sig_enabled ? (
              <div className="flex items-center text-[13px] leading-normal" style={{ fontFamily: "Arial, sans-serif" }}>
                {s.sig_logo && <img src="/signature-logo.png" alt="CritterPosts.ca" className="w-[150px] h-[35px] pr-3.5 mr-3.5 border-r-2 border-[#F5551E] box-content" />}
                <div>
                  <b className="text-[#12234A] text-sm block">{s.sig_name || box.display_name || "CritterPosts.ca"}</b>
                  {s.sig_title && <span className="text-slate-500 block">{s.sig_title}</span>}
                  <span className="text-[#F5551E] block">{box.address}</span>
                  {s.sig_phone && <span className="text-slate-500 block">{s.sig_phone}</span>}
                </div>
              </div>
            ) : <p className="text-sm text-slate-400">No signature</p>}
          </div>
          <div className="flex justify-end gap-2">
            <Button variant="outline" onClick={onClose} data-testid="sig-cancel">Cancel</Button>
            <Button onClick={save} data-testid="sig-save" className="bg-[#F5551E] hover:bg-[#e04a15]">Save signature</Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
